export default "__VITE_ASSET__CUT6ORRC__"